import './App.scss';
import { Home } from "./components/Home";
import { Planes } from "./components/Planes";
import { Resumen } from "./components/Resumen";
import { Routes, Route } from 'react-router-dom';

function App() {
  
  return (
    /*<div className="App">
      
     
    </div>*/
 
        <main>
           
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Planes" element={<Planes />} />
                    <Route path="/Resumen" element={<Resumen />} />
                </Routes>
                     
        </main>

  );
}

export default App;
